import { render } from "./Loan_Arrears.vue?vue&type=template&id=32913305"
import script from "./Loan_Arrears.vue?vue&type=script&lang=js"
export * from "./Loan_Arrears.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__